import React from 'react';
import api from '../services/api';
import { download, openPdf } from '../utils/certificates';

export const certificateFileName = (c, name) =>
  `Certificate_${c.number}${name ? `_${name.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_|_$/g, '')}` : ''}.pdf`;

// A certificate number that opens the PDF, with a button to download it.
const CertificateLink = ({ cert, name }) => (
  <span style={{ whiteSpace: 'nowrap' }}>
    <a href="#view" title="Open" onClick={e => { e.preventDefault(); openPdf(o => api.get(`/certificates/${cert.id}/pdf`, o)); }}>{cert.number}</a>
    {' '}
    <button type="button" className="btn btn-secondary btn-sm" title="Download PDF"
      style={{ padding: '1px 7px', fontSize: 12, lineHeight: 1.4 }}
      onClick={() => download(`/certificates/${cert.id}/pdf`, certificateFileName(cert, name))}>
      ⬇ PDF
    </button>
  </span>
);

export default CertificateLink;
